import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log('Formulario enviado:', formData);

    setLoading(true);
    setSuccessMessage('');
    setErrorMessage('');

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone || 'No proporcionado',
      message: formData.message,
    };




    // Valores por defecto en caso de que las variables de entorno no se lean correctamente
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_ybcjj4v';
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_rdd25y9';
    const userId = process.env.REACT_APP_EMAILJS_USER_ID || '5ut6cV5L-dnyf4zIA';

    console.log('Usando valores:');


    try {
      const result = await emailjs.send(serviceId, templateId, templateParams, userId);
      console.log('Email enviado:', result);
      setSuccessMessage('¡Gracias por contactarnos! Te responderemos pronto.');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('Error enviando el correo:', error);
      setErrorMessage('Hubo un problema al enviar tu mensaje. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <h1>Contáctanos</h1>
        <p>
          ¿Tienes alguna pregunta o necesitas más información? Llena el formulario a continuación y
          nuestro equipo se pondrá en contacto contigo.
        </p>

        {/* Formulario */}
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Nombre</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ingresa tu nombre completo"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Correo Electrónico</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Ingresa tu correo electrónico"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Teléfono</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Ingresa tu número de teléfono (opcional)"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Mensaje</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Escribe tu mensaje aquí"
              rows="5"
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar Mensaje'}
          </button>
        </form>

        {successMessage && <p className="success-message">{successMessage}</p>}
        {errorMessage && <p className="error-message">{errorMessage}</p>}

        {/* Redes Sociales */}

        <div className="social-section">
        <h2>Síguenos en redes sociales</h2>
        <p>Encuentra nuestras últimas novedades y actualizaciones:</p>
        <div className="social-icons">
            <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/sbk_soluciones_digitales/" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
            </a>
        </div>
        </div>

      </div>
    </div>
  );
};

export default ContactPage;
